import React from "react";

const Footer = ({}) => (
    <div className="footer text-center">
        Viled Group. Обслуживаем Вас с 1997 года...
    </div>
);

export default Footer;